import { createContext } from 'react';
var userDetails = {
  userId: '',
  user: {
    firstName: '',
    lastName: '',
    emailId: '',
    contactNo: '',
    roleName: '',
    countryCode: ''
  },
  userStatusId: '',
  userStatus: '',
  companyId: '',
  areCompanyDetailsCaptured: false,
  companyRegisteredStatus: '',
  companyRegStatusDescription: '',
  companyName: '',
  ciamId: '',
  dcsCompanyId: '',
  companyStatus: ''
};
var defaultState = {
  userData: userDetails,
  setUserDetailsFromInput: function setUserDetailsFromInput(userData) {
    return userData;
  }
};
var UserDetailsContext = /*#__PURE__*/createContext(defaultState);
export { UserDetailsContext, userDetails };